<!-- src/components/LayerPage7.vue -->
<template>
  <div class="whole-container">
    <div class="header">
      <h1> Bulk Transcriptomics of Epithelial Organoids (secretory) </h1>
      <div class="function_description">
          <p> Bulk RNA sequencing was performed on epithelial organoids (derived from endometrial biopsies collected in the proliferative phase of women with adenomyosis or healthy oocyte donors and differentiated into mid-secretory phases in vitro) using Illumina's NextSeq 550 NGS platform. Data was from the study of Juárez-Barber et al. (DOI: 10.1186/s12958-023-01182-7). </p>
        </div>
    </div>
    <GeneChoose uniqueId="function_7" function_name="function_7" description="Enter a gene to explore its expression in the epithelial organoids of secretory phase adenomyosis"></GeneChoose>
    <!-- Your content for Page 1 goes here -->
  </div>
</template>

<script>
import GeneChoose from '@/components/GeneChoose.vue';
export default {
  components: {
    GeneChoose,
},
  name: 'PageSeven'
}
</script>